export default {
  methods: {
    handleContentClick: function (evt) {
      const target = evt.target
      if(target.tagName === 'A' && window.cordova) {
          evt.preventDefault();

          if (target.href.indexOf("mailto:") > -1){
              // window.open(target.href, '_system');
              let email = target.href.replace("mailto:", "")
              cordova.plugins.email.open({ // eslint-disable-line
                  to: email,
              });
          }

          else if (target.href.indexOf("tel:") > -1){
              let number = target.href.replace("tel:", "")
              cordova.plugins.phonedialer.dial(number); // eslint-disable-line
          }

          else if (window.device.platform === 'Android') {
            if (target.href.endsWith(".pdf") || target.href.endsWith(".docx") || target.href.endsWith(".doc") || target.href.endsWith(".xls") || target.href.endsWith(".xlsx") || target.href.endsWith(".ppt") || target.href.endsWith(".pptx")) {
              window.cordova.InAppBrowser.open(target.href, "_system");
            } else {
              if (target.href.indexOf("http") > -1){
                window.cordova.InAppBrowser.open(target.href, "_blank", "toolbarposition=top,closebuttoncolor=#000000,toolbarcolor=#cccccc") // eslint-disable-line
              }
              else {
                window.cordova.InAppBrowser.open("http://" + target.href, "_blank", "toolbarposition=top,closebuttoncolor=#000000,toolbarcolor=#cccccc") // eslint-disable-line
              }
            }
          }

          //iOS - open documents with in app browser works, no location
          else if (window.device.platform === 'iOS') {
            if (target.href.indexOf("http") > -1){
              window.cordova.InAppBrowser.open(target.href, "_blank", "toolbarposition=top,closebuttoncolor=#000000,toolbarcolor=#cccccc,location=no") // eslint-disable-line
            }
            else {
              window.cordova.InAppBrowser.open("http://" + target.href, "_blank", "toolbarposition=top,closebuttoncolor=#000000,toolbarcolor=#cccccc,location=no") // eslint-disable-line
            }
          }

          //in case of any other do window.open
          else {
            window.open(target.href, '_blank');
          }

      }
    }
  }
}
